import { render, staticRenderFns } from "./UpLoadModel.vue?vue&type=template&id=5ec82dae&scoped=true&"
import script from "./UpLoadModel.vue?vue&type=script&lang=js&"
export * from "./UpLoadModel.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./UpLoadModel.vue?vue&type=style&index=0&id=5ec82dae&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5ec82dae",
  null
  ,true
)

export default component.exports